export default "__VITE_ASSET__CkS8E8P6__"